import { Component, OnDestroy, OnInit } from '@angular/core';
import { environment } from '@app/../environments/environment';
import {
  PromoBanner,
  PromoBannerGroup,
  PromoBlogBannerFormResult,
  PromoProductBannerFormResult
} from '@app/model/promo-banner-management.model';
import {
  parsePromoBannerStyle,
  PromoBannerStyle
} from '@app/model/promo-banner-style.model';
import { PromoBannerManagementDataService } from '@app/services/promo-banner-management-data.service';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { MatDialog } from '@angular/material';
import { PromoBlogBannerFormComponent } from './promo-blog-banner-form/promo-blog-banner-form.component';
import {
  PromoProductBannerFormComponent
} from './promo-product-banner-form/promo-product-banner-form.component';


@Component({
  selector: 'meu-promo-banner-management',
  templateUrl: './promo-banner-management.component.html',
  styleUrls: ['./promo-banner-management.component.scss']
})
export class PromoBannerManagementComponent implements OnInit, OnDestroy {
  group: PromoBannerGroup | null = null;
  blogBanner: PromoBanner | null = null;
  productBanner: PromoBanner | null = null;

  isLoading = false;

  private readonly subscriptions: Subscription[] = [];

  constructor(
    private promoBannerDataService: PromoBannerManagementDataService,
    private dialog: MatDialog,
    private toastr: ToastrService
  ) {}

  ngOnInit(): void {
    this.loadPromoBanners();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }

  loadPromoBanners(): void {
    if (this.isLoading) {
      return;
    }

    this.isLoading = true;

    const subscription = this.promoBannerDataService.getPromoBannerPageData().subscribe(
      (pageData) => {
        this.group = pageData.group;
        this.blogBanner = pageData.blogBanner;
        this.productBanner = pageData.productBanner;
        this.isLoading = false;

        if (!pageData.group) {
          this.toastr.warning('Không tìm thấy nhóm Promotion Banners');
        }
      },
      () => {
        this.group = null;
        this.blogBanner = null;
        this.productBanner = null;
        this.isLoading = false;

        this.toastr.error('Không thể tải dữ liệu Promo Banner');
      }
    );

    this.subscriptions.push(subscription);
  }
  openBlogBannerForm(): void {
    if (!this.group) {
      this.toastr.error('Không tìm thấy nhóm Promo Banner');

      return;
    }

    const dialogRef = this.dialog.open(PromoBlogBannerFormComponent, {
      width: '760px',
      maxWidth: 'calc(100vw - 32px)',
      maxHeight: '90vh',
      autoFocus: false,
      disableClose: true,
      panelClass: 'promo-blog-banner-dialog',
      data: {
        groupId: this.group.id,
        banner: this.blogBanner
      }
    });

    const subscription = dialogRef.afterClosed().subscribe((result: PromoBlogBannerFormResult) => {
      if (result && result.saved) {
        this.loadPromoBanners();
      }
    });

    this.subscriptions.push(subscription);
  }

  openProductBannerForm(): void {
    if (!this.group) {
      this.toastr.error('Không tìm thấy nhóm Promo Banner');

      return;
    }

    const dialogRef = this.dialog.open(PromoProductBannerFormComponent, {
      width: '760px',
      maxWidth: 'calc(100vw - 32px)',
      maxHeight: '90vh',
      autoFocus: false,
      disableClose: true,
      panelClass: 'promo-product-banner-dialog',
      data: {
        groupId: this.group.id,
        banner: this.productBanner
      }
    });

    const subscription = dialogRef.afterClosed().subscribe((result: PromoProductBannerFormResult) => {
      if (result && result.saved) {
        this.loadPromoBanners();
      }
    });

    this.subscriptions.push(subscription);
  }

  getBannerImageUrl(banner: PromoBanner | null): string | null {
    if (!banner || !banner.image) {
      return null;
    }

    if (
      banner.image.startsWith('http://') ||
      banner.image.startsWith('https://') ||
      banner.image.startsWith('data:')
    ) {
      return banner.image;
    }

    return environment.backendhost + banner.image;
  }

  getBannerStyle(banner: PromoBanner | null, fallbackLabel: string): PromoBannerStyle {
    return parsePromoBannerStyle(banner ? banner.add_info : null, fallbackLabel);
  }

  getBannerBackground(banner: PromoBanner | null): string {
    const imageUrl = this.getBannerImageUrl(banner);

    if (imageUrl) {
      return (
        'linear-gradient(90deg, rgba(0, 0, 0, 0.72), rgba(0, 0, 0, 0.18)), url(' +
        imageUrl +
        ')'
      );
    }

    return 'linear-gradient(135deg, #374151, #111827)';
  }
}
